module.exports = __webpack_public_path__ + "img/Rectangle 19header.cf882427.svg";